import type { CSSProperties } from "react";

export type ReadingTheme = "paper" | "sage" | "night";

export type ReadingPreferences = {
  theme: ReadingTheme;
  textScale: number;
};

export const DEFAULT_READING_PREFERENCES: ReadingPreferences = {
  theme: "paper",
  textScale: 1,
};

const THEMES = new Set<ReadingTheme>(["paper", "sage", "night"]);
const TEXT_SCALES = new Set([0.9, 1, 1.1, 1.15]);

export function parseReadingPreferences(raw: string | null): ReadingPreferences {
  if (!raw) return DEFAULT_READING_PREFERENCES;
  try {
    const value: unknown = JSON.parse(raw);
    if (typeof value !== "object" || value === null) {
      return DEFAULT_READING_PREFERENCES;
    }
    const record = value as Record<string, unknown>;
    if (
      typeof record.theme !== "string"
      || !THEMES.has(record.theme as ReadingTheme)
      || typeof record.textScale !== "number"
      || !TEXT_SCALES.has(record.textScale)
    ) {
      return DEFAULT_READING_PREFERENCES;
    }
    return {
      theme: record.theme as ReadingTheme,
      textScale: record.textScale,
    };
  } catch {
    return DEFAULT_READING_PREFERENCES;
  }
}

export function readingPreferenceStyle(
  preferences: ReadingPreferences,
): CSSProperties & { "--reader-text-scale": string } {
  return {
    "--reader-text-scale": preferences.textScale.toString(),
  };
}
